const getTitle = (key) => {
  switch (key) {
    case 'about':
      return 'About';
    case 'services':
      return 'Services';
    case 'refund-policy':
      return 'Refund Policy';

    default:
      return 'About';
  }
};

export default getTitle;
